import styled from 'styled-components'
import { Box } from 'src/components'
import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'

export const CardSection = styled(Box)`
    display: none;
    flex-direction: column;
    justify-content: start;
    align-items: center;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
    }
`
export const CardSectionResponsive = styled(Box)`
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        display: none;
    }
`
export const ImageContent = styled(motion(Box))<{ background: string }>`
    width: 256.28px;
    height: 305.01px;
    position: relative;
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
    border-radius: 15px 0 15px 0;
    background: ${({ background }) => background};
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 226.28px;
        height: 275.01px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 256.28px;
        height: 300px;
    }
`
export const ImageSection = styled.img`
    width: 100%;
    height: 100%;
    z-index: 10;
    object-fit: contain;
`
export const ContentButton = styled(motion(Box))`
    min-width: 164px;
    height: 24.87px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
`
export const RuteDirection = styled(Link)`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    flex-direction: row;
    position: absolute;
    color: ${({ theme }) => theme.colors.white};
    text-decoration: none;
    cursor: pointer;
    z-index: 100;
`
export const LinkDirection = styled.a`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    flex-direction: row;
    position: absolute;
    color: ${({ theme }) => theme.colors.white};
    text-decoration: none;
    cursor: pointer;
    z-index: 100;
`
export const ImageVector = styled.img`
    width: 10px;
    height: 20.89px;
    margin-left: 6px;
`
